import { GlobovmsLogo } from "../brand/GlobovmsLogo";

const platforms = [
  ["Genetec", "Access control"],
  ["LenelS2", "Access control"],
  ["Gallagher", "Access control"],
  ["Suprema", "Identity devices"],
  ["HikCentral", "Video"],
  ["Microsoft Entra ID", "Directory"],
];

export function IntegrationsSection() {
  return (
    <section id="integrations" className="scroll-mt-20 px-5 py-20">
      <div className="mx-auto grid max-w-7xl items-center gap-14 lg:grid-cols-2">
        <div>
          <p className="text-sm font-bold tracking-[0.16em] text-brand-blue">INTEGRATIONS</p>
          <h2 className="mt-3 text-4xl font-extrabold tracking-tight">Works with your existing security ecosystem</h2>
          <p className="mt-4 max-w-md text-slate-600">Designed for integration with leading access-control, identity, and security platforms. The dashed ring is the roadmap. None of these connections are live in this release.</p>
        </div>
        <div className="relative mx-auto h-[440px] w-full max-w-xl">
          <div className="pointer-events-none absolute left-8 top-10 h-40 w-40 rounded-full bg-brand-blue/30 blur-3xl" aria-hidden="true" />
          <div className="pointer-events-none absolute bottom-8 right-8 h-40 w-40 rounded-full bg-brand-orange/25 blur-3xl" aria-hidden="true" />
          <div className="absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full border border-dashed border-white/70 bg-white/20 backdrop-blur-md" aria-hidden="true" />
          <div className="absolute left-1/2 top-1/2 z-10 flex h-24 w-24 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-slate-300 bg-white/50 shadow-[inset_0_1px_0_rgba(255,255,255,0.7)] backdrop-blur-xl">
            <GlobovmsLogo compact />
          </div>
          {platforms.map(([name, kind], index) => {
            const angle = (index / platforms.length) * Math.PI * 2 - Math.PI / 2;
            const left = 50 + Math.cos(angle) * 40;
            const top = 50 + Math.sin(angle) * 40;
            return (
              <div
                key={name}
                className="absolute w-36 -translate-x-1/2 -translate-y-1/2 rounded-xl border border-slate-300 bg-white/45 px-3 py-3 text-center shadow-[inset_0_1px_0_rgba(255,255,255,0.8)] backdrop-blur-xl"
                style={{ left: `${left}%`, top: `${top}%` }}
              >
                <p className="text-sm font-bold text-brand-ink">{name}</p>
                <p className="mt-0.5 text-sm text-slate-500">{kind}</p>
                <p className="mt-2 text-sm font-bold tracking-wide text-brand-orange">PLANNED</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
